export const baseUrl = 'https://storeapi.isai-dev.com/api/';
export const baseUrlServices = 'https://storeapi.isai-dev.com/api/';
